export enum AvailableCurrency {
  GBP = 'GBP',
  EUR = 'EUR',
  USD = 'USD',
}

const euTimezones = [
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Astrakhan',
  'Europe/Athens',
  'Europe/Belfast',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Helsinki',
  'Europe/Isle_of_Man',
  'Europe/Lisbon',
  'Europe/Ljubljana',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Monaco',
  'Europe/Moscow',
  'Europe/Nicosia',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/San_Marino',
  'Europe/Sarajevo',
  'Europe/Skopje',
  'Europe/Sofia',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Tiraspol',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zurich',
];

const gbTimezones = ['Europe/London'];

export const getCurrencyByTimezone = (timeZone: string) => {
  switch (true) {
    case euTimezones.some((tz) => tz === timeZone):
      return AvailableCurrency.EUR;
    case gbTimezones.some((tz) => tz === timeZone):
      return AvailableCurrency.GBP;
    default:
      return AvailableCurrency.USD;
  }
};

export const getCurrency = () => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  return getCurrencyByTimezone(timeZone);
};
